import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { Action } from 'redux';
import type { ThunkAction } from 'redux-thunk';

import store from './store';

export interface InitialLoadingState {
  loading: LoadingState;
}
export interface LoadingState {
  [actionName: string]: boolean;
}

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
